import styled from 'styled-components';
import {checklistColors} from 'styles/palette';
import $Icon from 'components/Icon';

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin: 0 32px 16px 32px;
  justify-content: center;
`;

export const OptionWrapper = styled.div`
  transition: all 0.3s;
  border-radius: 5px;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${p => (p.disabled ? 'default' : 'pointer')};
  margin: 15px 0;
  border: 2px solid transparent;

  @media (max-width: 1100px) {
    width: 40px;
    height: 40px;
  }

  ${p => {
    const borderColor = p.value === 0 ? checklistColors.red : checklistColors.green;
    const backgroundColor = p.selected ? borderColor : checklistColors.white;

    return `
      border-color: ${borderColor};
      background-color: ${backgroundColor};
    `;
  }}
`;

export const Icon = styled($Icon).attrs(p => ({
  name: p.value === 0 ? 'close' : 'checkmark'
}))`
  height: ${p => (p.value === 0 ? '15px' : '25px')};
  color: ${({selected, value}) =>
    selected ? checklistColors.white : value === 0 ? checklistColors.red : checklistColors.green};
`;
